import { createSlice } from '@reduxjs/toolkit'
import { Product } from './productReducers'
import { getOrdersUserAPI } from '../actions/orderActions'

export interface OrderItem {
  product: Product
  quantity: number
  _id: string
  createdAt: string
  updatedAt: string
}

export interface Order {
  _id: string
  user: string
  email: string
  address: string
  phone: string
  company: string
  country: string
  status: string
  total_order: number
  items: OrderItem[]
  payment_option: string
  createdAt: string
  updatedAt: string
  __v: number
}

export type OrdersUser = {
  success: boolean
  loading: boolean
  orders: Order[]
}

const initialState: OrdersUser = {
  success: false,
  loading: false,
  orders: []
}

export const orderSlices = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // getAllProducts: async () => {
    //   const data = await fetchProducts()
    // },
  },
  extraReducers: builders => {
    builders.addCase(getOrdersUserAPI.fulfilled, (state, action) => {
      state.orders = action.payload.orders
      state.success = action.payload.success
    })
  }
})

export const all = orderSlices.actions

export default orderSlices.reducer
